module.exports = __webpack_public_path__ + "img/shein.b4d3c4a1.png";